import { HighlightMatch } from '@/components/shared/HighlightMatch';
import type { CommandResult } from './types';

interface CommandPaletteItemProps {
  result: CommandResult;
  query: string;
  selected: boolean;
  onSelect: () => void;
  onHover: () => void;
}

export function CommandPaletteItem({
  result,
  query,
  selected,
  onSelect,
  onHover,
}: CommandPaletteItemProps) {
  const Icon = result.icon;

  return (
    <button
      type="button"
      data-item-id={result.id}
      onClick={onSelect}
      onMouseEnter={onHover}
      className={`relative flex w-full cursor-default select-none items-center gap-2 rounded-sm px-2 py-2 text-sm outline-hidden ${
        selected ? 'bg-accent text-accent-foreground' : ''
      }`}
    >
      {Icon && <Icon className="h-4 w-4 shrink-0" />}
      <div className="flex-1 min-w-0 text-left">
        <div className="truncate">
          <HighlightMatch text={result.label} query={query} />
        </div>
        {result.subtitle && (
          <div className="text-xs text-muted-foreground truncate">
            <HighlightMatch text={result.subtitle} query={query} />
          </div>
        )}
      </div>
      {result.shortcut && (
        <span className="ml-auto text-xs text-muted-foreground">{result.shortcut}</span>
      )}
    </button>
  );
}
